import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { CountryId } from '@entities/country';
import { OperatorId } from '@entities/operator';
import bannerMain from './images/emirates-banner-main.webp';
import bannerSerp from './images/emirates-banner-serp.webp';

interface EmiratesPromoBannerProps {
    variant?: 'main' | 'serp';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmiratesPromoBanner',
  props: {
    variant: { default: 'main' }
  },
  setup(__props: any) {

const props = __props as { variant: 'main' | 'serp' }



const EMIRATES_SERP_URL = `/search#?toCountry=${CountryId.Uae}&block=true&f_operators=${OperatorId.Travelata.join('.')}`;

const bannerSrc = computed(() => (props.variant === 'serp' ? bannerSerp : bannerMain));

return { __sfc: true,props, EMIRATES_SERP_URL, bannerSrc }
}

})